export { default as NRate, rateProps } from './src/Rate';
